const KEY = "cookie_consent";

export const getConsent = () => {
  try { return JSON.parse(localStorage.getItem(KEY)); } catch { return null; }
};

export const analyticsAllowed = () => !!getConsent()?.analytics;

export const saveConsent = (analytics) => {
  localStorage.setItem(KEY, JSON.stringify({ necessary: true, analytics, at: new Date().toISOString() }));
  if (!analytics) localStorage.removeItem("visitor_id");
  window.dispatchEvent(new Event("consent-change"));
};

export const openCookieSettings = () => window.dispatchEvent(new Event("cookie-settings"));
